import React from "react";
import { Card } from "antd";

import "./CardComponent.css";

export const AccountCardComponent = props => {
  return (
    <Card
      className={`card ${props.className}`}
      style={{ minHeight: `${props.min_height}rem` }}
    >
      <div>{props.children}</div>
    </Card>
  );
};
